import { render, staticRenderFns } from "./SpecialRequests.vue?vue&type=template&id=49dd1ff8"
import script from "./SpecialRequests.vue?vue&type=script&lang=ts"
export * from "./SpecialRequests.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports